import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { GenericComponentsModule } from '@helios/generic-components'
import { ExternalTransactionsGridModule } from './external-transactions-grid/external-transactions-grid.module'
import { ExternalTransactionsPanelComponent } from './external-transactions-panel.component'
import { ExternalTransactionsService } from './services/external-transactions.service'
import { HttpExternalTransactionsService } from './services/http-external-transactions.service'
@NgModule({
  imports: [
    CommonModule,

    //helios modules
    GenericComponentsModule,
    ExternalTransactionsGridModule,
  ],
  declarations: [ExternalTransactionsPanelComponent],
  exports: [ExternalTransactionsPanelComponent],
  providers: [
    {
      provide: ExternalTransactionsService,
      useClass: HttpExternalTransactionsService,
    },
  ],
})
export class ExternalTransactionsPanelModule {}

export { ExternalTransactionsPanelComponent }
